import Enum from "./Enum";

export default Enum.create( {
	BOTTOM: "BOTTOM",
	TOP: "TOP",
} );
